export type ArchiveActionType = 'archive_loading' | 'archive_loaded' | 'archive_error';

export const ARCHIVE_LOADING: ArchiveActionType = 'archive_loading';
export const ARCHIVE_LOADED: ArchiveActionType = 'archive_loaded';
export const ARCHIVE_ERROR: ArchiveActionType = 'archive_error';
